export default __webpack_public_path__ + "static/presse-huettn-2-preview-ba2d3ee0bc0fef60a0913a24a1c764a8.jpg";